<template>

<div class="login-wrapper">
    <div class="container" id="container">

      <div class="form-container sign-up-container">
        <!-- Main registration form -->
        <form v-if="!showDomainRequest" @submit.prevent="signup_obj()">
          <div class="form-header">
          <h1>{{ $t('pages.Log_Reg.create_account_eff4fd8') }}</h1>
            <p class="subtitle">{{ $t('pages.Log_Reg.use_your_hong_kong_university_emai_9179d02') }}</p>
          </div>

          <div class="input-group">
            <div class="input-with-button">
              <input type="email" :placeholder="$t('pages.Log_Reg.university_email_2d10f47')" v-model="reg_email" required>
              <button type="button" class="verify-button" @click.prevent="handleClick()">
                {{ $t('pages.Log_Reg.verify_dda6ac2') }}
              </button>
            </div>
          </div>

          <div class="input-group">
            <input type="text" :placeholder="$t('pages.Log_Reg.verification_code_50cdc18')" v-model="reg_code" required>
          </div>

          <div class="input-group">
            <input type="text" :placeholder="$t('pages.Log_Reg.full_name_64346b4')" v-model="reg_name" required>
          </div>

          <div class="input-group">
            <input type="password" :placeholder="$t('pages.Log_Reg.password_8be3c94')" v-model="reg_psd" required>
          </div>

          <Vcode :show="isShow" @success="success" @close="close"
            :canvasWidth="puzzleWidth" :canvasHeight="puzzleHeight" :sliderSize="puzzleSlider"
            :successText="$t('pages.Log_Reg.verified_f6cc6a5')" :failText="$t('pages.Log_Reg.try_again_042c862')" :sliderText="$t('pages.Log_Reg.slide_to_verify_68b61e8')" />

          <div class="consent-group">
            <label class="consent-checkbox">
              <input type="checkbox" v-model="agreeTerms" required />
              <span>{{ $t('pages.Log_Reg.agree_terms_prefix_fd9c616') }}<a :href="termsOfUseHref" target="_blank" rel="noopener" class="legal-inline-link">{{ $t('pages.Log_Reg.terms_of_use_link_3e81a3c') }}</a>{{ $t('pages.Log_Reg.agree_terms_middle_66e6680') }}<a :href="privacyPolicyHref" target="_blank" rel="noopener" class="legal-inline-link">{{ $t('pages.Log_Reg.privacy_policy_link_c3fe6d6') }}</a>{{ $t('pages.Log_Reg.agree_terms_and2_e1f9f9e') }}<a :href="picsHref" target="_blank" rel="noopener" class="legal-inline-link">{{ $t('pages.Log_Reg.pics_link_f2a31b8') }}</a>.</span>
            </label>
            <label class="consent-checkbox">
              <input type="checkbox" v-model="agreeAccountPersonal" required />
              <span>{{ $t('pages.Log_Reg.agree_account_personal_b66aa09') }}</span>
            </label>
          </div>

          <button type="submit" class="submit-button" :disabled="!canSubmitSignup">
            <span>{{ $t('pages.Log_Reg.sign_up_2ba4023') }}</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>

          <div class="mobile-toggle-link">
            <p class="mobile-promo">{{ $t('pages.Log_Reg.welcome_back_to_keep_connected_wit_235aae1') }}</p>
            {{ $t('pages.Log_Reg.already_have_an_account_8559034') }} <a href="#" @click.prevent="switchToSignIn">{{ $t('pages.Log_Reg.sign_in_f8492cc') }}</a>
          </div>
        </form>

        <!-- Domain-not-allowed: request domain addition -->
        <form v-else @submit.prevent="submitDomainRequest()">
          <div class="form-header">
            <h1>{{ $t('pages.Log_Reg.domain_not_supported_ef85cbc') }}</h1>
            <p class="subtitle">{{ $t('pages.Log_Reg.your_university_is_not_yet_on_spar_31e8c27') }}</p>
          </div>

          <div class="input-group">
            <input type="email" :value="reg_email" readonly class="input-readonly"
              :title="$t('pages.Log_Reg.the_email_you_entered_9680274')" />
          </div>

          <div class="input-group">
            <input type="text" :placeholder="$t('pages.Log_Reg.university_name_eb33cf0')" v-model="domainReqUniversity" required>
          </div>

          <div class="input-group">
            <input type="text" :placeholder="$t('pages.Log_Reg.note_optional_4e39567')" v-model="domainReqNote">
          </div>

          <button type="submit" class="submit-button" :disabled="domainReqSubmitting">
            <span>{{ domainReqSubmitting ? 'Sending…' : 'Request Access' }}</span>
          </button>

          <div class="mobile-toggle-link" style="margin-top:12px;">
            <a href="#" @click.prevent="showDomainRequest = false">{{ $t('pages.Log_Reg.back_to_sign_up_8927212') }}</a>
          </div>
        </form>
      </div>

      <div class="form-container sign-in-container">
        <form id="form1" @submit.prevent="signin_obj()">
          <div class="form-header">
            <h1>{{ $t('pages.Log_Reg.welcome_back_1c90894') }}</h1>
            <p class="subtitle">{{ $t('pages.Log_Reg.sign_in_to_continue_to_your_accoun_791f0bb') }}</p>
          </div>
          
          <div class="input-group">
            <input type="email" :placeholder="$t('pages.Log_Reg.email_84add5b')" v-model="email" required />
          </div>
          
          <div class="input-group">
            <input type="password" :placeholder="$t('pages.Log_Reg.password_8be3c94')" v-model="password" required />
          </div>
          
          <div class="form-footer">
            <a href="#" class="forgot-password" @click.prevent="goToForgotPassword">{{ $t('pages.Log_Reg.forgot_password_4c29f7f') }}</a>
          </div>
          
          <button type="submit" class="submit-button">
            <span>{{ $t('pages.Log_Reg.sign_in_f8492cc') }}</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          
          <div class="mobile-toggle-link">
            <p class="mobile-promo">{{ $t('pages.Log_Reg.hello_friend_enter_your_personal_d_faf18f4') }}</p>
            {{ $t('pages.Log_Reg.don_t_have_an_account_f838dc1') }} <a href="#" @click.prevent="switchToSignUp">{{ $t('pages.Log_Reg.sign_up_2ba4023') }}</a>
          </div>
        </form>
      </div>

      <div class="overlay-container">
        <div class="overlay">
          <div class="overlay-panel overlay-left">
            <div class="overlay-content">
              <h1>{{ $t('pages.Log_Reg.welcome_back_7927e5d') }}</h1>
              <p>{{ $t('pages.Log_Reg.to_keep_connected_with_us_please_l_a7f6a8b') }}</p>
              <button type="button" class="ghost-button" id="signIn">
                {{ $t('pages.Log_Reg.sign_in_f8492cc') }}
              </button>
            </div>
          </div>
          <div class="overlay-panel overlay-right">
            <div class="overlay-content">
              <h1>{{ $t('pages.Log_Reg.hello_friend_c896fbc') }}</h1>
              <p>{{ $t('pages.Log_Reg.enter_your_personal_details_and_st_26cd777') }}</p>
              <button type="button" class="ghost-button" id="signUp">
                {{ $t('pages.Log_Reg.sign_up_2ba4023') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>

</template>
  
<script>
import Vcode from "vue-puzzle-vcode";
import axios from 'axios';
import Swal from 'sweetalert2';
import { syncStoredAuthFromToken } from '@/utils/auth';
import { userFacingApiMessage } from '@/utils/apiMessages';

export default {
  components:{
    Vcode
  },
  data(){
    return{
      email:'',
      password:'',
      isShow: false,
      reg_email:'',
      reg_name:'',
      reg_code:'',
      reg_psd:'',
      agreeTerms: false,
      agreeAccountPersonal: false,
      windowWidth: window.innerWidth,
      signInSubmitting: false,
      signUpSubmitting: false,
      // Domain-request form state
      showDomainRequest: false,
      domainReqUniversity: '',
      domainReqNote: '',
      domainReqSubmitting: false,
    }
  },
  computed: {
    puzzleWidth() {
      // Must fit: canvasWidth + 2*padding(14) + 2*bodyMargin must be < screen width
      // On a 375px phone with no margins: max usable ~340px, minus 40px padding = 300px canvas
      // On a 320px phone: max usable ~290px, minus 40px = 250px canvas
      if (this.windowWidth <= 400) return Math.min(this.windowWidth - 70, 250);
      if (this.windowWidth <= 768) return Math.min(this.windowWidth - 80, 280);
      return 310;
    },
    puzzleHeight() {
      if (this.windowWidth <= 400) return 120;
      if (this.windowWidth <= 768) return 140;
      return 160;
    },
    puzzleSlider() {
      if (this.windowWidth <= 400) return 36;
      return 50;
    },
    // Gate for the sign-up submit button: both consent checkboxes must be
    // ticked before registration can proceed (see signup_obj() for the
    // second line of defence in case the button state is bypassed).
    canSubmitSignup() {
      return this.agreeTerms && this.agreeAccountPersonal;
    },
    // Resolved via the router so these always match the registered routes
    // (see router/index.js) and open the standalone legal pages.
    termsOfUseHref() {
      return this.$router.resolve({ path: '/terms-of-use' }).href;
    },
    privacyPolicyHref() {
      return this.$router.resolve({ path: '/privacy-policy' }).href;
    },
    picsHref() {
      return this.$router.resolve({ path: '/privacy-policy', hash: '#appendix-a' }).href;
    },
  },
  methods: {
    handleClick() {
      // 点击按钮时，先展示验证码组件
      this.isShow = true;
      console.log(this.reg_email);
    },
    success() {
      this.isShow = false; // 通过验证后，需要手动隐藏模态框
      const email = String(this.reg_email || '').trim().toLowerCase();
      axios.post('/api/user/auth/send-reg-code', null, { params: { email } })
        .then((response) => {
          const payload = response && response.data;
          if (payload && Number(payload.code) === 1) {
            Swal.fire({
              icon: 'success',
              title: 'Code Sent',
              text: 'A 6-digit verification code has been sent to your university email.',
              timer: 2500,
              showConfirmButton: false,
            });
          } else {
            const msg = payload && payload.msg;
            if (msg === 'EMAIL_DOMAIN_NOT_ALLOWED') {
              this.showDomainRequest = true;
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Could Not Send Code',
                text: userFacingApiMessage(msg, 'Please check your email address and try again.'),
                confirmButtonColor: '#3bc2ff',
              });
            }
          }
        })
        .catch((error) => {
          const msg = error?.response?.data?.msg;
          if (msg === 'EMAIL_DOMAIN_NOT_ALLOWED') {
            this.showDomainRequest = true;
            return;
          }
          Swal.fire({
            icon: 'error',
            title: 'Could Not Send Code',
            text: userFacingApiMessage(msg, 'Please check your email address and try again.'),
            confirmButtonColor: '#3bc2ff',
          });
        });
    },
    // 用户点击遮罩层，应该关闭模态框
    close() {
      this.isShow = false;
    },
    submitDomainRequest() {
      if (this.domainReqSubmitting) return;
      if (!this.domainReqUniversity || !this.domainReqUniversity.trim()) {
        Swal.fire({ icon: 'warning', title: 'University Required', text: 'Please enter your university name.', confirmButtonColor: '#3bc2ff' });
        return;
      }
      this.domainReqSubmitting = true;
      axios
        .post('/api/user/auth/domain-request', {
          email: String(this.reg_email || '').trim().toLowerCase(),
          university: this.domainReqUniversity.trim(),
          note: this.domainReqNote ? this.domainReqNote.trim() : null,
        })
        .then((response) => {
          const payload = response && response.data;
          if (payload && Number(payload.code) === 1) {
            Swal.fire({
              icon: 'success',
              title: 'Request Submitted',
              html: '<p>Thank you! Our team will review your request and add your university soon.</p>',
              confirmButtonColor: '#3bc2ff',
            }).then(() => {
              this.showDomainRequest = false;
              this.domainReqUniversity = '';
              this.domainReqNote = '';
            });
          } else {
            Swal.fire({ icon: 'error', title: 'Submission Failed', text: userFacingApiMessage(payload && payload.msg, 'Could not submit your request. Please try again.'), confirmButtonColor: '#3bc2ff' });
          }
        })
        .catch((error) => {
          Swal.fire({ icon: 'error', title: 'Submission Failed', text: userFacingApiMessage(error?.response?.data?.msg, 'Could not submit your request. Please try again.'), confirmButtonColor: '#3bc2ff' });
        })
        .finally(() => {
          this.domainReqSubmitting = false;
        });
    },
    signup_obj(){
      // Second line of defence: the submit button is already disabled until
      // both consent checkboxes are checked, but guard here too in case that
      // state is ever bypassed (e.g. programmatic submit).
      if (!this.agreeTerms || !this.agreeAccountPersonal) {
        Swal.fire({
          icon: 'warning',
          title: this.$t('pages.Log_Reg.agreement_required_title_f81748c'),
          text: this.$t('pages.Log_Reg.agreement_required_text_14d1733'),
          confirmButtonColor: '#3bc2ff',
        });
        return;
      }

      // Enhanced validation for registration
      const errors = [];

      if (!this.reg_email || !this.reg_email.trim()) {
        errors.push('Email is required');
      } else if (!this.isValidEmail(this.reg_email)) {
        errors.push('Please enter a valid email address');
      }
      
      if (!this.reg_name || !this.reg_name.trim()) {
        errors.push('Name is required');
      } else if (this.reg_name.trim().length < 2) {
        errors.push('Name must be at least 2 characters long');
      }
      
      if (!this.reg_code || !this.reg_code.trim()) {
        errors.push('Verification code is required');
      }
      
      if (!this.reg_psd || !this.reg_psd.trim()) {
        errors.push('Password is required');
      } else if (this.reg_psd.length < 6) {
        errors.push('Password must be at least 6 characters long');
      }
      
      if (errors.length > 0) {
        Swal.fire({
          icon: 'warning',
          title: '<span style="color: #2c3e50; font-size: 1.5rem; font-weight: 600;">Please Complete Required Fields</span>',
          html: `
            <div style="text-align: left; margin: 20px 0;">
              <div style="background: #fff3cd; border: 1px solid #ffeaa7; border-radius: 8px; padding: 15px; margin-bottom: 15px;">
                <div style="color: #856404; font-weight: 600; margin-bottom: 10px;">Required Information:</div>
                <div style="color: #856404;">
                  ${errors.map(error => `<div style="margin: 8px 0; padding-left: 20px; position: relative;">
                    <span style="position: absolute; left: 0; color: #e74c3c;">•</span>
                    ${error}
                  </div>`).join('')}
                </div>
              </div>
            </div>
          `,
          confirmButtonText: 'Got it!',
          confirmButtonColor: '#3bc2ff',
          background: '#f8f9fa'
        });
        return;
      }
      
      this.sign_up();
    },
    signin_obj(){
      // Enhanced validation for login
      const errors = [];
      
      if (!this.email || !this.email.trim()) {
        errors.push('Email is required');
      } else if (!this.isValidEmail(this.email)) {
        errors.push('Please enter a valid email address');
      }
      
      if (!this.password || !this.password.trim()) {
        errors.push('Password is required');
      }
      
      if (errors.length > 0) {
        Swal.fire({
          icon: 'warning',
          title: '<span style="color: #2c3e50; font-size: 1.5rem; font-weight: 600;">Please Complete Required Fields</span>',
          html: `
            <div style="text-align: left; margin: 20px 0;">
              <div style="background: #fff3cd; border: 1px solid #ffeaa7; border-radius: 8px; padding: 15px; margin-bottom: 15px;">
                <div style="color: #856404; font-weight: 600; margin-bottom: 10px;">Required Information:</div>
                <div style="color: #856404;">
                  ${errors.map(error => `<div style="margin: 8px 0; padding-left: 20px; position: relative;">
                    <span style="position: absolute; left: 0; color: #e74c3c;">•</span>
                    ${error}
                  </div>`).join('')}
                </div>
              </div>
            </div>
          `,
          confirmButtonText: 'Got it!',
          confirmButtonColor: '#3bc2ff',
          background: '#f8f9fa'
        });
        return;
      }
      
      this.sign_in();
    },
    sign_up(){
      if (this.signUpSubmitting) return;
      this.signUpSubmitting = true;

      axios
        .post('/api/user/auth/register', {
          email: String(this.reg_email || '').trim().toLowerCase(),
          password: this.reg_psd,
          code: this.reg_code,
          name: this.reg_name,
        })
        .then((response) => {
          let payload = response && response.data;
          if (typeof payload === 'string') {
            try {
              payload = JSON.parse(payload);
            } catch (e) {
              payload = null;
            }
          }

          const data = payload && payload.data;
          const token = data ? String(data.token != null ? data.token : '').trim() : '';
          const ok = payload && Number(payload.code) === 1 && token.length > 0;

          if (!ok) {
            Swal.fire({
              icon: 'error',
              title: 'Sign Up Failed',
              text: userFacingApiMessage(
                payload && payload.msg,
                'Registration failed. Check your email, verification code, and password.'
              ),
              confirmButtonColor: '#3bc2ff',
            });
            return;
          }

          localStorage.setItem('token', token);
          const session = syncStoredAuthFromToken(token);
          if (!session) {
            Swal.fire({
              icon: 'error',
              title: 'Sign Up Failed',
              text: 'Could not save your session. Try signing in instead.',
              confirmButtonColor: '#3bc2ff',
            });
            return;
          }

          window.dispatchEvent(new Event('sparrow-auth-updated'));
          // Registration succeeded: reset the consent checkboxes so a stale
          // checked state is never carried into a future sign-up attempt.
          this.agreeTerms = false;
          this.agreeAccountPersonal = false;
          this.ToRegInfo();
        })
        .catch((error) => {
          const raw =
            error.userMessage ||
            error?.response?.data?.msg ||
            error?.message ||
            '';
          Swal.fire({
            icon: 'error',
            title: 'Sign Up Failed',
            text: userFacingApiMessage(raw, 'Registration failed. Please try again.'),
            confirmButtonColor: '#3bc2ff',
          });
        })
        .finally(() => {
          this.signUpSubmitting = false;
        });
    },
    sign_in(){
      if (this.signInSubmitting) return;
      this.signInSubmitting = true;

      Swal.fire({
        title: 'Logging in...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const loginEmail = String(this.email || '').trim().toLowerCase();
      axios
        .post('/api/user/login', {
          email: loginEmail,
          password: this.password,
        })
        .then((response) => {
          Swal.close();

          let payload = response && response.data;
          if (typeof payload === 'string') {
            try {
              payload = JSON.parse(payload);
            } catch (e) {
              payload = null;
            }
          }

          const data = payload && payload.data;
          const code = payload && payload.code;
          const token = data ? String(data.token != null ? data.token : '').trim() : '';

          const ok = payload && Number(code) === 1 && token.length > 0;

          if (!ok) {
            Swal.fire({
              icon: 'error',
              title: 'Login Failed',
              text: userFacingApiMessage(
                payload && payload.msg,
                'Invalid email or password.'
              ),
              confirmButtonColor: '#3bc2ff',
            });
            return;
          }

          localStorage.setItem('token', token);
          const session = syncStoredAuthFromToken(token);
          if (!session) {
            Swal.fire({
              icon: 'error',
              title: 'Login Failed',
              text: 'Could not restore your session. Try again or contact support.',
              confirmButtonColor: '#3bc2ff',
            });
            return;
          }

          window.dispatchEvent(new Event('sparrow-auth-updated'));
          this.ToMain();
          Swal.fire({
            icon: 'success',
            title: 'Login Successful!',
            text: 'Redirecting…',
            timer: 1500,
            showConfirmButton: false,
          });
        })
        .catch((error) => {
          console.error('Login error:', error);
          Swal.close();

          let errorMessage = 'Login failed. Please try again.';

          if (error.userMessage) {
            errorMessage = error.userMessage;
          } else if (error.response) {
            const d = error.response.data;
            if (typeof d === 'object' && d !== null && d.msg != null) {
              errorMessage = userFacingApiMessage(d.msg, String(d.msg));
            } else if (
              typeof d === 'string' &&
              (d.includes('Proxy error') || d.includes('ECONNREFUSED'))
            ) {
              errorMessage =
                'Cannot reach the backend (development proxy failed). Ensure Spring Boot is running on port 8088.';
            } else {
              errorMessage = `Server error: ${error.response.status}`;
            }
          } else if (error.request) {
            const networkFailed =
              error.code === 'ERR_NETWORK' || /network error/i.test(String(error && error.message));
            if (networkFailed) {
              errorMessage =
                'Cannot reach the app or API. Start Spring Boot on port 8088, run `npm run serve` in the frontend folder, and open http://localhost:8081 from that process.';
            } else {
              errorMessage =
                'Unable to connect. Check that the dev server (npm run serve) and Spring Boot are running.';
            }
          } else if (error.message) {
            errorMessage = error.message;
          }

          Swal.fire({
            icon: 'error',
            title: 'Login Error',
            text: errorMessage,
            confirmButtonColor: '#3bc2ff',
          });
        })
        .finally(() => {
          this.signInSubmitting = false;
        });
    },
  ToRegInfo(){
    if (this.$route.path !== '/RegInfo') {
        this.$router.push('/RegInfo');
      } else {
        console.log('Already on RegInfo page');
      }
  },    ToLogin(){
      if (this.$route.path !== '/LogReg') {
      this.$router.push('/LogReg');
    } else {
      console.log('Already on LogReg page');
    }
    },
  Tolog(){
    if (this.$route.path !== '/RegInfo') {
      console.log('loginfo')
        this.$router.push('/RegInfo');
      } else {
        console.log('Already on RegInfo page');
      }
  },
  
  // Email validation helper method
  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },
  ToMain() {
        // Honor ?redirect=... if the user came from a protected route,
        // otherwise land on the main page.
        const redirect = this.$route.query && this.$route.query.redirect;
        const target = (redirect && typeof redirect === 'string' && redirect.startsWith('/'))
          ? redirect
          : '/MainPage';
        if (this.$route.fullPath !== target) {
          // replace so the browser does not "back" onto the login screen after success
          this.$router.replace(target);
        } else {
          console.log('Already on target page:', target);
        }
  },
  
  switchToSignUp() {
    const container = document.getElementById('container');
    if (container) {
      container.classList.add('right-panel-active');
    }
  },
  
  switchToSignIn() {
    const container = document.getElementById('container');
    if (container) {
      container.classList.remove('right-panel-active');
    }
  },
  goToForgotPassword() {
    Swal.fire({
      title: 'Reset Your Password',
      html: '<input id="swal-email" class="swal2-input" placeholder="your@email.com" type="email" autocomplete="email">',
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Send Code',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#3bc2ff',
      cancelButtonColor: '#94a3b8',
      allowOutsideClick: false,
      buttonsStyling: false,
      width: 'min(calc(100vw - 28px), 360px)',
      padding: '14px',
      customClass: {
        popup: 'forgot-password-popup',
        confirmButton: 'swal-btn-confirm',
        cancelButton: 'swal-btn-cancel',
        actions: 'swal-actions-horizontal'
      },
      didOpen: () => {
        const input = document.getElementById('swal-email');
        if (input) input.focus();
      },
      preConfirm: () => {
        const emailInput = document.getElementById('swal-email');
        const email = emailInput ? emailInput.value : '';
        if (!email) {
          Swal.showValidationMessage('Please enter your email address');
          return false;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          Swal.showValidationMessage('Please enter a valid email address');
          return false;
        }
        return email;
      }
    }).then((result) => {
      if (!result.isConfirmed) return;
      const email = result.value;

      Swal.fire({
        title: 'Sending verification code...',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      axios.get('/api/user/sendMailToo', { params: { email } })
        .then(() => {
          return Swal.fire({
            title: 'Reset Password',
            html:
              '<div class="forgot-password-form-stack">' +
              '<div class="forgot-password-field"><label class="forgot-password-label" for="swal-code">Verification Code</label>' +
              '<input id="swal-code" class="swal2-input" placeholder="6-digit code from email" autocomplete="off"></div>' +
              '<div class="forgot-password-field"><label class="forgot-password-label" for="swal-newpwd">New Password</label>' +
              '<input id="swal-newpwd" class="swal2-input" placeholder="At least 6 characters" type="password" autocomplete="new-password"></div>' +
              '</div>',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Reset Password',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#3bc2ff',
            cancelButtonColor: '#94a3b8',
            allowOutsideClick: false,
            buttonsStyling: false,
            width: 'min(calc(100vw - 28px), 360px)',
            padding: '14px',
            customClass: {
              popup: 'forgot-password-popup',
              confirmButton: 'swal-btn-confirm',
              cancelButton: 'swal-btn-cancel',
              actions: 'swal-actions-vertical'
            },
            didOpen: () => {
              const codeInput = document.getElementById('swal-code');
              if (codeInput) codeInput.focus();
            },
            preConfirm: () => {
              const codeEl = document.getElementById('swal-code');
              const pwdEl = document.getElementById('swal-newpwd');
              const code = codeEl ? codeEl.value : '';
              const newPassword = pwdEl ? pwdEl.value : '';

              if (!code) {
                Swal.showValidationMessage('Please enter the verification code');
                return false;
              }
              if (!newPassword) {
                Swal.showValidationMessage('Please enter a new password');
                return false;
              }
              if (newPassword.length < 6) {
                Swal.showValidationMessage('Password must be at least 6 characters long');
                return false;
              }
              return { code, newPassword };
            }
          });
        })
        .then((result2) => {
          if (!result2 || !result2.isConfirmed) return;
          const { code, newPassword } = result2.value;

          Swal.fire({
            title: 'Resetting password...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading()
          });

          return axios
            .post('/api/user/forget', {
              email: String(email || '').trim().toLowerCase(),
              code,
              password: newPassword,
            })
            .then((res) => {
              const p = res && res.data;
              if (!p || Number(p.code) !== 1) {
                return Promise.reject(new Error((p && p.msg) || 'Reset failed'));
              }
              return Swal.fire({
                icon: 'success',
                title: 'Password Reset Successfully!',
                html: '<p style="color: #475569; line-height: 1.6;">Your password has been reset.<br/>You can now sign in with your new password.</p>',
                confirmButtonText: 'Sign In',
                confirmButtonColor: '#3bc2ff',
                allowOutsideClick: false,
                width: 'min(calc(100vw - 28px), 340px)',
                padding: '14px',
                customClass: { popup: 'forgot-password-popup' },
              }).then(() => {
                this.switchToSignIn();
              });
            })
            .catch((err) => {
              console.error('Reset error:', err);
              const errorMsg =
                err.message ||
                err.response?.data?.msg ||
                'Invalid code or server error. Please try again.';
              Swal.fire({
                icon: 'error',
                title: 'Reset Failed',
                text: errorMsg,
                confirmButtonColor: '#3bc2ff',
                width: 'min(calc(100vw - 28px), 340px)',
                padding: '14px',
                customClass: { popup: 'forgot-password-popup' },
              });
            });
        })
        .catch((err) => {
          const d = err.response?.data
          const isBizFail =
            d && typeof d.code === 'number' && d.code === 0
          if (isBizFail) {
            console.warn('[sendMailToo] API:', d.msg != null ? d.msg : 'failed')
          } else {
            console.error('SendMailToo error:', err)
          }
          let errorMsg = 'Could not send verification code. Please check your email and try again.';
          if (err.userMessage) {
            errorMsg = err.userMessage;
          } else if (err.message) {
            errorMsg = err.message;
          } else if (err.response?.data?.msg) {
            errorMsg = err.response.data.msg;
          } else if (err.response?.status === 401) {
            errorMsg = 'Email not found. Please check and try again.';
          }
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMsg,
            confirmButtonColor: '#3bc2ff',
            width: 'min(calc(100vw - 28px), 340px)',
            padding: '14px',
            customClass: { popup: 'forgot-password-popup' },
          });
        });
    });
  }
  },
  
  mounted(){
    this._onResize = () => { this.windowWidth = window.innerWidth; };
    window.addEventListener('resize', this._onResize);

    const signUpButton = document.getElementById('signUp');
    const signInButton = document.getElementById('signIn');
    const container = document.getElementById('container');

    if (signUpButton && container) {
      signUpButton.addEventListener('click', () => {
        container.classList.add("right-panel-active")
      })
    }

    if (signInButton && container) {
      signInButton.addEventListener('click', () => {
        container.classList.remove("right-panel-active")
      })
    }
  },
  beforeDestroy() {
    if (this._onResize) window.removeEventListener('resize', this._onResize);
  }
}





</script>
  
<style>
@import './css/css2.css';
@import './css/style.css';
/* FontAwesome is imported globally in main.js */
.valbut{
  height: 38px;
  margin-top: 10px;
}

/* ---------- Registration consent checkboxes ---------- */
.consent-group {
  width: 100%;
  padding: 0 5px;
  box-sizing: border-box;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.consent-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  text-align: left;
  cursor: pointer;
  font-size: 13px;
  line-height: 1.5;
  color: #4a5568;
}

.consent-checkbox input[type="checkbox"] {
  flex: none;
  width: 18px;
  height: 18px;
  min-width: 18px;
  margin: 1px 0 0;
  accent-color: #3bc2ff;
  cursor: pointer;
}

.consent-checkbox span {
  flex: 1;
  min-width: 0;
}

.legal-inline-link {
  color: #3bc2ff;
  font-weight: 600;
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: color 0.2s ease, text-decoration-color 0.2s ease;
}

.legal-inline-link:hover,
.legal-inline-link:focus {
  color: rgba(60, 194, 255, 1);
  text-decoration-color: currentColor;
}

.submit-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
  transform: none !important;
}

@media (max-width: 768px) {
  .consent-group {
    padding: 0 5px;
    margin-bottom: 12px;
  }

  .consent-checkbox {
    font-size: 13px;
  }
}

/* Read-only email field in domain-request form */
.input-readonly {
  background: #f1f5f9 !important;
  color: #64748b !important;
  cursor: default !important;
}

/* Hide mobile-only elements on desktop */
.mobile-toggle-link {
  display: block;
}

/* Promo copy shown only on mobile (desktop has the same copy in .overlay-right /
   .overlay-left panels). One source of truth: same strings live as siblings of
   the toggle link, so updates here are picked up on mobile and editing the
   desktop overlay does not silently diverge. */
.mobile-promo {
  display: none;
}

/* Puzzle captcha mobile fixes */
.vue-puzzle-vcode {
  z-index: 9999 !important;
}

@media (max-width: 768px) {
  .vue-auth-box_ {
    max-width: calc(100vw - 40px) !important;
    width: auto !important;
    padding: 12px !important;
    box-sizing: border-box !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    overflow: hidden !important;
  }
  .vue-auth-box_ .auth-body_ {
    border-radius: 8px !important;
    max-width: 100% !important;
    overflow: hidden !important;
  }
  .vue-auth-box_ .auth-body_ canvas {
    max-width: none !important;
  }
  .vue-auth-box_ .auth-control_ {
    max-width: 100% !important;
    overflow: hidden !important;
  }
  .vue-auth-box_ .auth-control_ .range-box {
    margin-top: 12px !important;
    border-radius: 8px !important;
    max-width: 100% !important;
    overflow: hidden !important;
    touch-action: none !important;
  }
  .vue-auth-box_ .auth-control_ .range-box .range-slider {
    max-width: 100% !important;
  }
  .vue-auth-box_ .auth-control_ .range-box .range-slider .range-btn {
    border-radius: 8px !important;
  }
  .vue-auth-box_ .auth-control_ .range-box .range-text {
    font-size: 12px !important;
  }
}

@media (max-width: 400px) {
  .vue-auth-box_ {
    max-width: calc(100vw - 24px) !important;
    padding: 10px !important;
  }
}

/* ========================================
   MOBILE RESPONSIVE STYLES (max-width: 768px)
   ======================================== */

@media (max-width: 768px) {
  .login-wrapper {
    padding: 0;
    background: rgba(60, 194, 255, 1);
  }

  .login-wrapper .container {
    min-height: 100vh;
    margin: 0;
    border-radius: 0;
    width: 100vw;
    box-shadow: none;
  }

  .form-container {
    width: 100%;
    padding: 0;
    position: static !important;
    background: white;
    margin: 0;
    border-radius: 0;
  }

  .sign-in-container,
  .sign-up-container {
    width: 100%;
    opacity: 1 !important;
    display: block;
    transform: none !important;
  }
  
  .sign-in-container {
    display: block;
  }
  
  .sign-up-container {
    display: none;
  }
  
  .login-wrapper .container.right-panel-active .sign-in-container {
    display: none;
  }
  
  .login-wrapper .container.right-panel-active .sign-up-container {
    display: block;
    transform: none !important;
    opacity: 1 !important;
  }

  .form-container form {
    padding: 24px 24px;
    background: transparent;
    min-height: auto;
  }

  .form-header h1 {
    font-size: 2rem;
    margin-bottom: 8px;
  }
  
  .subtitle {
    font-size: 14px;
    margin-bottom: 0;
  }

  .input-group {
    margin-bottom: 18px;
  }

  .login-wrapper input {
    padding: 14px 18px;
    font-size: 15px;
    border-radius: 12px;
  }
  
  .login-wrapper input:focus {
    box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
  }

  .verify-button {
    padding: 14px 20px;
    font-size: 13px;
    border-radius: 12px;
  }

  .submit-button {
    padding: 16px 40px;
    font-size: 15px;
    margin-top: 10px;
    border-radius: 12px;
  }
  
  .forgot-password {
    font-size: 13px;
  }

  .overlay-container {
    display: none;
  }

  /* Mobile toggle between sign in/up */
  .mobile-toggle-link {
    display: block !important;
    text-align: center;
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid #e2e8f0;
    font-size: 14px;
    color: #718096;
  }

  .mobile-promo {
    display: block;
    margin: 0 0 12px;
    font-size: 13px;
    line-height: 1.4;
    color: #94a3b8;
  }

  .mobile-toggle-link a {
    color: #3bc2ff;
    text-decoration: none;
    font-weight: 600;
    margin-left: 4px;
    transition: color 0.3s ease;
  }
  
  .mobile-toggle-link a:hover {
    color: rgba(60, 194, 255, 1);
  }
}

/* ========== SWAL2 FORGOT PASSWORD STYLING ========== */
.forgot-password-popup {
  border-radius: 20px !important;
  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.2) !important;
  border: none !important;
  background: #ffffff !important;
  padding: 24px 20px !important;
  max-width: min(360px, calc(100vw - 28px)) !important;
  width: 100% !important;
  box-sizing: border-box !important;
  overflow-x: hidden !important;
}

.forgot-password-form-stack {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  text-align: left;
}

.forgot-password-field {
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}

.forgot-password-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #374151;
}

.forgot-password-popup .swal2-title {
  color: #0f172a !important;
  font-size: 1.35rem !important;
  font-weight: 700 !important;
  margin-bottom: 8px !important;
  line-height: 1.25 !important;
}

.forgot-password-popup .swal2-html-container {
  color: #475569 !important;
  font-size: 0.95rem !important;
  line-height: 1.6 !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  overflow-x: hidden !important;
}

.forgot-password-popup .swal2-input {
  border: 2px solid #e2e8f0 !important;
  border-radius: 10px !important;
  padding: 12px 16px !important;
  font-size: 15px !important;
  color: #1e293b !important;
  transition: all 0.2s ease !important;
  background: #ffffff !important;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  box-sizing: border-box !important;
  margin: 0 !important;
}

.forgot-password-popup .swal2-input:focus {
  border-color: #3bc2ff !important;
  box-shadow: 0 0 0 4px rgba(59, 194, 255, 0.12) !important;
  outline: none !important;
}

.forgot-password-popup .swal2-input::placeholder {
  color: #94a3b8 !important;
}

.forgot-password-popup .swal2-actions {
  display: flex !important;
  gap: 12px !important;
  justify-content: center !important;
  margin-top: 16px !important;
}

/* Use homepage button system for forgot-password flow */
.swal-btn-confirm,
.swal2-confirm {
  background: #3bc2ff !important;
  border: none !important;
  border-radius: 10px !important;
  padding: 12px 28px !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  color: white !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 4px 12px rgba(59, 194, 255, 0.25) !important;
}

.swal-btn-confirm:hover,
.swal2-confirm:hover {
  transform: translateY(-2px) !important;
  background: #22b7f8 !important;
  box-shadow: 0 6px 18px rgba(59, 194, 255, 0.35) !important;
}

.swal-btn-confirm:active,
.swal2-confirm:active {
  transform: translateY(0) !important;
}

/* Secondary button mirrors homepage outlined button style */
.swal-btn-cancel,
.swal2-cancel {
  background: #ffffff !important;
  border: 2px solid #3bc2ff !important;
  border-radius: 10px !important;
  padding: 12px 28px !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  color: #3bc2ff !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

.swal-btn-cancel:hover,
.swal2-cancel:hover {
  background: #3bc2ff !important;
  border-color: #3bc2ff !important;
  color: #ffffff !important;
}

.swal-actions-horizontal {
  flex-direction: row !important;
}

.swal-actions-vertical {
  flex-direction: column !important;
}

.forgot-password-popup .swal2-icon {
  border-color: #3bc2ff !important;
}

.forgot-password-popup .swal2-icon.swal2-info {
  color: #3bc2ff !important;
}

.forgot-password-popup .swal2-icon.swal2-success {
  border-color: #22c55e !important;
  color: #22c55e !important;
}

.forgot-password-popup .swal2-icon.swal2-error {
  border-color: #ef4444 !important;
  color: #ef4444 !important;
}

.forgot-password-popup .swal2-validation-message {
  color: #ef4444 !important;
  font-size: 13px !important;
  margin-top: 8px !important;
}

/* ========== SWAL2 MODAL MOBILE RESPONSIVE ========== */
@media (max-width: 768px) {
  /* SweetAlert modal responsive */
  .swal2-container {
    padding: 10px !important;
  }
  
  .forgot-password-popup {
    width: auto !important;
    max-width: min(340px, calc(100vw - 28px)) !important;
    margin: 0 auto !important;
    padding: 16px 14px !important;
    max-height: min(82vh, 560px) !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }

  .forgot-password-popup .swal2-icon {
    width: 2.75rem !important;
    height: 2.75rem !important;
    margin: 0.2rem auto 0 !important;
  }
  
  .forgot-password-popup .swal2-title {
    font-size: 1.1rem !important;
    padding: 6px 4px 4px !important;
  }
  
  .forgot-password-popup .swal2-html-container {
    font-size: 14px !important;
    padding: 6px 4px 2px !important;
  }
  
  .forgot-password-popup .swal2-actions,
  .swal-actions-horizontal,
  .swal-actions-vertical {
    padding: 0 !important;
    gap: 8px !important;
    margin-top: 12px !important;
  }

  .forgot-password-popup .swal2-actions.swal-actions-vertical {
    flex-direction: column !important;
  }

  .forgot-password-popup .swal2-actions.swal-actions-horizontal {
    flex-direction: row !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
  }
  
  .swal-btn-confirm,
  .swal-btn-cancel,
  .swal2-confirm,
  .swal2-cancel,
  .swal2-deny {
    padding: 9px 14px !important;
    font-size: 13px !important;
    border-radius: 8px !important;
    min-height: 40px !important;
  }

  .forgot-password-popup .swal2-actions.swal-actions-vertical .swal-btn-confirm,
  .forgot-password-popup .swal2-actions.swal-actions-vertical .swal-btn-cancel,
  .forgot-password-popup .swal2-actions.swal-actions-vertical .swal2-confirm,
  .forgot-password-popup .swal2-actions.swal-actions-vertical .swal2-cancel {
    width: 100% !important;
    min-width: 0 !important;
  }

  .forgot-password-popup .swal2-actions.swal-actions-horizontal .swal-btn-confirm,
  .forgot-password-popup .swal2-actions.swal-actions-horizontal .swal-btn-cancel {
    width: calc(50% - 4px) !important;
    min-width: 0 !important;
  }

  .forgot-password-popup .swal2-actions:not(.swal-actions-horizontal) .swal2-confirm:only-child,
  .forgot-password-popup .swal2-actions:not(.swal-actions-horizontal) .swal-btn-confirm:only-child {
    width: 100% !important;
    max-width: 100% !important;
  }
  
  /* Input fields in modals */
  .forgot-password-popup .swal2-input {
    padding: 10px 12px !important;
    font-size: 16px !important;
    border-radius: 8px !important;
    border: 2px solid #e2e8f0 !important;
    margin: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box !important;
  }

  .forgot-password-label {
    font-size: 12px !important;
  }

  .forgot-password-form-stack {
    gap: 12px !important;
  }
  
  .forgot-password-popup .swal2-input:focus {
    border-color: #3bc2ff !important;
    box-shadow: 0 0 0 3px rgba(59, 194, 255, 0.1) !important;
  }
}

@media (max-width: 480px) {
  .forgot-password-popup {
    width: auto !important;
    max-width: min(320px, calc(100vw - 24px)) !important;
    border-radius: 14px !important;
    padding: 12px 12px !important;
    max-height: min(78vh, 520px) !important;
  }

  .forgot-password-popup .swal2-icon {
    width: 2.4rem !important;
    height: 2.4rem !important;
  }
  
  .forgot-password-popup .swal2-title {
    font-size: 1.02rem !important;
    padding: 4px 2px 2px !important;
  }
  
  .forgot-password-popup .swal2-html-container {
    font-size: 13px !important;
    padding: 4px 2px 0 !important;
  }
  
  .forgot-password-popup .swal2-actions {
    padding: 0 !important;
    margin-top: 10px !important;
  }

  .forgot-password-popup .swal2-actions.swal-actions-vertical {
    flex-direction: column !important;
  }

  .forgot-password-popup .swal2-actions.swal-actions-horizontal {
    flex-direction: row !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
  }

  .swal-btn-confirm,
  .swal-btn-cancel,
  .swal2-confirm,
  .swal2-cancel,
  .swal2-deny {
    padding: 10px 12px !important;
    font-size: 12px !important;
    min-height: 38px !important;
  }

  .forgot-password-popup .swal2-actions.swal-actions-vertical .swal-btn-confirm,
  .forgot-password-popup .swal2-actions.swal-actions-vertical .swal-btn-cancel,
  .forgot-password-popup .swal2-actions.swal-actions-vertical .swal2-confirm,
  .forgot-password-popup .swal2-actions.swal-actions-vertical .swal2-cancel {
    width: 100% !important;
    min-width: 0 !important;
  }

  .forgot-password-popup .swal2-actions.swal-actions-horizontal .swal-btn-confirm,
  .forgot-password-popup .swal2-actions.swal-actions-horizontal .swal-btn-cancel {
    width: calc(50% - 4px) !important;
    min-width: 0 !important;
  }

  .forgot-password-popup .swal2-actions:not(.swal-actions-horizontal) .swal2-confirm:only-child,
  .forgot-password-popup .swal2-actions:not(.swal-actions-horizontal) .swal-btn-confirm:only-child {
    width: 100% !important;
    max-width: 100% !important;
  }
  
  .forgot-password-popup .swal2-input {
    padding: 9px 11px !important;
    font-size: 16px !important;
    width: 100% !important;
    box-sizing: border-box !important;
    margin: 0 !important;
    min-width: 0 !important;
  }

  .forgot-password-form-stack {
    gap: 10px !important;
  }
}

/* Extra small mobile devices */
@media (max-width: 375px) {
  .form-container form {
      padding: 32px 24px;
  }

    .form-header h1 {
      font-size: 1.75rem;
  }

    .login-wrapper input {
      padding: 12px 16px;
    font-size: 14px;
  }
  
    .verify-button {
      padding: 12px 16px;
    font-size: 12px;
  }

    .submit-button {
      padding: 14px 32px;
      font-size: 14px;
  }
  
  .mobile-toggle-link {
    font-size: 13px;
    margin-top: 20px;
    padding-top: 20px;
  }
}
</style>
